import { useQuery } from "@tanstack/react-query";
import { RequestKey } from "api/request-key";
import { apiV2 } from "api/firebase";

type Args = {
  page: number;
  limit: number;
};

export const useAdminVerifiedDomains = ({ page, limit }: Args) => {
  const { data, isFetching, isLoading } = useQuery({
    queryKey: [RequestKey.GetVerifiedDomainsByAdmin, page, limit],
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    queryFn: () => apiV2.verifiedDomain.getByAdmin({ page, limit }),
  });

  return {
    items: data?.items ?? [],
    total: data?.meta?.totalItems ?? 0,
    isLoading: isLoading || isFetching,
  };
};
